
import { useCallback, useEffect, useMemo, useState } from "react";
import { DataTable } from "../../dataTables/data-table"
import { deteleTechnicianById, fetchTecnnicians } from "@/apiCalls/apiCalls";
import { Button } from "@/components/ui/button";
import { Technicians, techniciansColumns } from "@/pages/technicians/TechniciansColumns";
import Spinner from "../spinnner/Spinner";
import CreateTechnicianDrawer from "./CreateTechnicianDrawer";
import UpdateTechnicianDrawer from "./UpdateTechnicianDrawer";
import AddBeaconToTechnicianDrawer from "./AddBeaconToTechnicianDrawer";
import { jwtDecode } from "jwt-decode"
import useAuth from "@/hooks/useAuth";
import { TecniciansDataTables } from "./TechniciansDataTables";
import { useLocation, useNavigate } from "react-router-dom";
import useAxiosPrivate from "@/context/UseAxiosPrivate";
import { errorNotification, successNotification } from "@/utils/Notification";
import axios from "axios";


export default function TechniciansFn() {
    const [data, setData] = useState<Technicians[]>([])
    const [loading, setLoading] = useState<boolean>(true)
    const [showUpdateTechnicianDrawer, setShowUpdateTecnicianDrawer] = useState(false)
    const [showCreateTechnicianDrawer, setShowCreateTecnicianDrawer] = useState(false)
    const [showAddBeaconToTechnicianDrawer, setShowAddBeaconToTechnicianDrawer] = useState(false)
    const [tecnicianData, setTechnicianData] = useState<Technicians | undefined>(undefined)
    const { auth } = useAuth()
    let token: any = auth.accessToken
    const decoded: any = jwtDecode(token);
    let roles: string[] = decoded.UserInfo.roles
    const navigate = useNavigate()
    const location = useLocation()
    const axiosPrivate = useAxiosPrivate()

    const getTechnicians = () => {
        setLoading(true)
        let isMounted = true;
        const controller = new AbortController()
        axiosPrivate.get('/api/v1/technicians', {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: Technicians[]) => {
                if (isMounted) {
                    setData(data)
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    let errror = errors?.[0]?.message
                    errorNotification(
                        "There was an issue",
                        `${errror}`,
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification(
                            "There was an issue",
                            `${errorMessage}`,
                            'topRight'
                        );
                    });
                } else {
                    errorNotification(
                        "There was an issue",
                        "No server reponse",
                        'topRight'
                    );
                    navigate('/', { state: { from: location }, replace: true });
                }
            }).finally(() => {
                setLoading(false)
            })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    useEffect(() => {
        getTechnicians()
    }, [])

    const getClientIPAndURL = async () => {
        try {

            const response = await axios.get('https://api.ipify.org?format=json');
            const clientIp = response.data.ip
            const currentUrl = window.location.href
            return { clientIp, currentUrl }
        } catch (error) {
            console.error('Error fetching IP address:', error);
            return { clientIp: 'Unknown', currentUrl: window.location.href }
        }
    }


    const deteleTechnicianById = (technicianId: any) => {
        let isMounted = true;
        const controller = new AbortController()
        getClientIPAndURL().then(({ clientIp, currentUrl }) => {
            return axiosPrivate.delete(`/api/v1/technicians/${technicianId}`, {
                signal: controller.signal,
                headers: {
                    'X-Client-IP': clientIp,
                    'X-Origin-URL': currentUrl
                }
            })
        }).then((response: any) =>
            response.data.data
        ).then((data: any) => {
            if (isMounted) {
                successNotification(
                    "technician successfully deleted",
                    `technician  was deleted`,
                    'topRight'
                );

            }
            getTechnicians()
        }).catch((err: any) => {
            const errors = err?.response?.data?.errors;
            if (errors && errors?.[0]?.message === "token as expired") {
                let errror = errors?.[0]?.message
                errorNotification(
                    "There was an issue",
                    `${errror}`,
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            } else if (errors && Array.isArray(errors) && errors.length > 0) {
                errors.forEach((error: any) => {
                    const errorMessage = error.message || "An unknown error occurred";
                    errorNotification(
                        "There was an issue",
                        `${errorMessage}`,
                        'topRight'
                    );
                });
            } else {
                errorNotification(
                    "There was an issue",
                    "No server reponse",
                    'topRight'
                );
                navigate('/', { state: { from: location }, replace: true });
            }
        })
        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    const editProductFunctionCall = (technicians: Technicians) => {
        setTechnicianData(technicians)
        setShowUpdateTecnicianDrawer(!showUpdateTechnicianDrawer)
    }

    const deleteProductFunctionCall = (technicians: Technicians) => {
        deteleTechnicianById(technicians.id)
    }
    const addBeaconToTechincianFunctionCall = (technicians: Technicians) => {
        setTechnicianData(technicians)
        setShowAddBeaconToTechnicianDrawer(!showAddBeaconToTechnicianDrawer)
    }

    const onDelete = useCallback(
        (technicians: Technicians) => deleteProductFunctionCall(technicians),
        []
    )

    const onEdit = useCallback(
        (technicians: Technicians) => editProductFunctionCall(technicians),
        []
    )


    const onAddBeaconsToTechnicians = useCallback(
        (technicians: Technicians) => addBeaconToTechincianFunctionCall(technicians),
        []
    )


    const techniciansColumnsData = useMemo(() => techniciansColumns({ onEdit, onDelete, onAddBeaconsToTechnicians, roles }), [])

    if (loading) {
        return <Spinner />
    }

    return (
        <main className='mx-3 mt-16 sm:ml-[300px] sm:mt-3'>

            {roles.includes('technician-create') && (
                <Button
                    variant='default'
                    className="flex items-center justify-end"
                    onClick={() => setShowCreateTecnicianDrawer(!showCreateTechnicianDrawer)}
                >
                    Create Technician
                </Button>
            )}
            <TecniciansDataTables columns={techniciansColumnsData} data={data} filterNameColumn="uuid" />

            {roles.includes('technician-create') && showCreateTechnicianDrawer && (
                <CreateTechnicianDrawer
                    showCreateTechnicianDrawer={showCreateTechnicianDrawer}
                    setShowCreateTecnicianDrawer={setShowCreateTecnicianDrawer}
                    getTechnicians={getTechnicians}
                />
            )}

            {tecnicianData && roles.includes('technician-edit') && (
                <UpdateTechnicianDrawer
                    showUpdateTechnicianDrawer={showUpdateTechnicianDrawer}
                    setShowUpdateTecnicianDrawer={setShowUpdateTecnicianDrawer}
                    technicians={tecnicianData}
                    getTechnicians={getTechnicians}
                    setTechnicianData={setTechnicianData}
                />
            )}


            {tecnicianData && roles.includes('beacon-edit') && (
                <AddBeaconToTechnicianDrawer
                    showAddBeaconToTechnicianDrawer={showAddBeaconToTechnicianDrawer}
                    setShowAddBeaconToTechnicianDrawer={setShowAddBeaconToTechnicianDrawer}
                    technicians={tecnicianData}
                    setTechnicianData={setTechnicianData}
                />
            )}
        </main>
    )
}